
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"ci-primary",attrs:{"fill":"#0fb0e1","d":"M478.465 89.022L329.6 47.382 180.3 89.438 41.459 50.052A20 20 0 0016 69.293v340.6a24.093 24.093 0 0017.449 23.089l146.817 41.65 149.365-42.074 140.983 39.436A20 20 0 00496 452.728V112.135a24.08 24.08 0 00-17.535-23.113zM163 436.466L48 403.842V85.17l115 32.624zm150.615-32.647L195 437.231V118.542L313.615 85.13zM464 436.91L345.615 403.8V85.089L464 118.2z"}})])
          )
        }
      }
    